import { render, staticRenderFns } from "./ChartBarPercentageComponent.vue?vue&type=template&id=5f46c30a&scoped=true"
import script from "./ChartBarPercentageComponent.vue?vue&type=script&lang=js"
export * from "./ChartBarPercentageComponent.vue?vue&type=script&lang=js"
import style0 from "@/other/assets/css/app.css?vue&type=style&index=0&id=5f46c30a&prod&scoped=true&lang=css&external"
import style1 from "./ChartBarPercentageComponent.vue?vue&type=style&index=1&id=5f46c30a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f46c30a",
  null
  
)

export default component.exports